import { useEffect, useRef, useState } from 'react';

function injectTradingViewWidget(container: HTMLDivElement | null, src: string, config: object) {
  if (!container) return;
  // Clear previous embeds (hot-reload safe)
  container.innerHTML = '';
  const script = document.createElement('script');
  script.src = src;
  script.type = 'text/javascript';
  script.async = true;
  script.innerHTML = JSON.stringify(config);
  container.appendChild(script);
}

export default function LiveGoldForex() {
  const tapeRef = useRef<HTMLDivElement>(null);
  const goldRef = useRef<HTMLDivElement>(null);
  const eurRef = useRef<HTMLDivElement>(null);
  const silverRef = useRef<HTMLDivElement>(null);
  const platinumRef = useRef<HTMLDivElement>(null);
  const palladiumRef = useRef<HTMLDivElement>(null);
  const copperRef = useRef<HTMLDivElement>(null);
  const aluminumRef = useRef<HTMLDivElement>(null);
  const inrRef = useRef<HTMLDivElement>(null);
  const pkrRef = useRef<HTMLDivElement>(null);
  const egpRef = useRef<HTMLDivElement>(null);
  const aedRef = useRef<HTMLDivElement>(null);
  const sarRef = useRef<HTMLDivElement>(null);
  const nickelRef = useRef<HTMLDivElement>(null);
  const zincRef = useRef<HTMLDivElement>(null);
  const leadRef = useRef<HTMLDivElement>(null);
  const tinRef = useRef<HTMLDivElement>(null);
  const ironRef = useRef<HTMLDivElement>(null);
  const gbpRef = useRef<HTMLDivElement>(null);
  const jpyRef = useRef<HTMLDivElement>(null);
  const cadRef = useRef<HTMLDivElement>(null);
  const audRef = useRef<HTMLDivElement>(null);
  const chfRef = useRef<HTMLDivElement>(null);


  const [selectedMetal, setSelectedMetal] = useState<string>('All');
  const [selectedFX, setSelectedFX] = useState<string>('All');

  useEffect(() => {
    injectTradingViewWidget(tapeRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js', {
      symbols: [
        { proName: 'OANDA:XPDUSD', title: 'Palladium' },
        { proName: 'FX:EURUSD', title: 'EUR/USD' },
        { proName: 'FX:GBPUSD', title: 'GBP/USD' },
        { proName: 'FX:USDJPY', title: 'USD/JPY' },
        { proName: 'FX:USDCAD', title: 'USD/CAD' },
      ],
      showSymbolLogo: false,
      isTransparent: true,
      displayMode: 'adaptive',
      colorTheme: 'light',
      locale: 'en',
    });

    // Primary metal mini chart (Palladium)
    injectTradingViewWidget(goldRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'OANDA:XPDUSD',
      width: '100%',
      height: 240,
      dateRange: '12M',
      colorTheme: 'light',
      trendLineColor: 'rgba(99, 102, 241, 1)',
      underLineColor: 'rgba(99, 102, 241, 0.15)',
      isTransparent: true,
      locale: 'en'
    });

    injectTradingViewWidget(eurRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'FX:EURUSD',
      width: '100%',
      height: 240,
      dateRange: '12M',
      colorTheme: 'light',
      trendLineColor: 'rgba(37, 99, 235, 1)',
      underLineColor: 'rgba(37, 99, 235, 0.15)',
      isTransparent: true,
      locale: 'en'
    });

    // Metals mini charts
    injectTradingViewWidget(silverRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'OANDA:XAGUSD',
      width: '100%',
      height: 240,
      dateRange: '12M',
      colorTheme: 'light',
      trendLineColor: 'rgba(16, 185, 129, 1)',
      underLineColor: 'rgba(16, 185, 129, 0.15)',
      isTransparent: true,
      locale: 'en'
    });
    injectTradingViewWidget(platinumRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'OANDA:XPTUSD',
      width: '100%',
      height: 240,
      dateRange: '12M',
      colorTheme: 'light',
      trendLineColor: 'rgba(147, 51, 234, 1)',
      underLineColor: 'rgba(147, 51, 234, 0.15)',
      isTransparent: true,
      locale: 'en'
    });
    injectTradingViewWidget(palladiumRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'OANDA:XAUUSD',
      width: '100%',
      height: 240,
      dateRange: '12M',
      colorTheme: 'light',
      trendLineColor: 'rgba(234, 179, 8, 1)',
      underLineColor: 'rgba(234, 179, 8, 0.15)',
      isTransparent: true,
      locale: 'en'
    });
    injectTradingViewWidget(copperRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'CAPITALCOM:COPPER',
      width: '100%',
      height: 240,
      dateRange: '12M',
      colorTheme: 'light',
      trendLineColor: 'rgba(234, 88, 12, 1)',
      underLineColor: 'rgba(234, 88, 12, 0.15)',
      isTransparent: true,
      locale: 'en'
    });
    injectTradingViewWidget(aluminumRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'CAPITALCOM:ALUMINIUM',
      width: '100%',
      height: 240,
      dateRange: '12M',
      colorTheme: 'light',
      trendLineColor: 'rgba(2, 132, 199, 1)',
      underLineColor: 'rgba(2, 132, 199, 0.15)',
      isTransparent: true,
      locale: 'en'
    });

    // Additional FX
    injectTradingViewWidget(inrRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'FX_IDC:USDINR',
      width: '100%',
      height: 240,
      dateRange: '12M',
      colorTheme: 'light',
      trendLineColor: 'rgba(37, 99, 235, 1)',
      underLineColor: 'rgba(37, 99, 235, 0.15)',
      isTransparent: true,
      locale: 'en'
    });
    injectTradingViewWidget(pkrRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'FX_IDC:USDPKR',
      width: '100%',
      height: 240,
      dateRange: '12M',
      colorTheme: 'light',
      trendLineColor: 'rgba(37, 99, 235, 1)',
      underLineColor: 'rgba(37, 99, 235, 0.15)',
      isTransparent: true,
      locale: 'en'
    });
    injectTradingViewWidget(egpRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'FX_IDC:USDEGP',
      width: '100%',
      height: 240,
      dateRange: '12M',
      colorTheme: 'light',
      trendLineColor: 'rgba(37, 99, 235, 1)',
      underLineColor: 'rgba(37, 99, 235, 0.15)',
      isTransparent: true,
      locale: 'en'
    });
    injectTradingViewWidget(aedRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'FX_IDC:USDAED',
      width: '100%',
      height: 240,
      dateRange: '12M',
      colorTheme: 'light',
      trendLineColor: 'rgba(37, 99, 235, 1)',
      underLineColor: 'rgba(37, 99, 235, 0.15)',
      isTransparent: true,
      locale: 'en'
    });
    injectTradingViewWidget(sarRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'FX_IDC:USDSAR',
      width: '100%',
      height: 240,
      dateRange: '12M',
      colorTheme: 'light',
      trendLineColor: 'rgba(37, 99, 235, 1)',
      underLineColor: 'rgba(37, 99, 235, 0.15)',
      isTransparent: true,
      locale: 'en'
    });
    // Additional base metals
    injectTradingViewWidget(nickelRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'CAPITALCOM:NICKEL',
      width: '100%', height: 240, dateRange: '12M', colorTheme: 'light',
      trendLineColor: 'rgba(99, 102, 241, 1)', underLineColor: 'rgba(99, 102, 241, 0.15)', isTransparent: true, locale: 'en'
    });
    injectTradingViewWidget(zincRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'CAPITALCOM:ZINC',
      width: '100%', height: 240, dateRange: '12M', colorTheme: 'light',
      trendLineColor: 'rgba(16, 185, 129, 1)', underLineColor: 'rgba(16, 185, 129, 0.15)', isTransparent: true, locale: 'en'
    });
    injectTradingViewWidget(leadRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'CAPITALCOM:LEAD',
      width: '100%', height: 240, dateRange: '12M', colorTheme: 'light',
      trendLineColor: 'rgba(234, 88, 12, 1)', underLineColor: 'rgba(234, 88, 12, 0.15)', isTransparent: true, locale: 'en'
    });
    injectTradingViewWidget(tinRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'CAPITALCOM:TIN',
      width: '100%', height: 240, dateRange: '12M', colorTheme: 'light',
      trendLineColor: 'rgba(2, 132, 199, 1)', underLineColor: 'rgba(2, 132, 199, 0.15)', isTransparent: true, locale: 'en'
    });
    injectTradingViewWidget(ironRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'COMEX:TIO1!',
      width: '100%', height: 240, dateRange: '12M', colorTheme: 'light',
      trendLineColor: 'rgba(15, 118, 110, 1)', underLineColor: 'rgba(15, 118, 110, 0.15)', isTransparent: true, locale: 'en'
    });

    // Additional major FX pairs
    injectTradingViewWidget(gbpRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'FX:GBPUSD',
      width: '100%', height: 240, dateRange: '12M', colorTheme: 'light',
      trendLineColor: 'rgba(37, 99, 235, 1)', underLineColor: 'rgba(37, 99, 235, 0.15)', isTransparent: true, locale: 'en'
    });
    injectTradingViewWidget(jpyRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'FX:USDJPY',
      width: '100%', height: 240, dateRange: '12M', colorTheme: 'light',
      trendLineColor: 'rgba(37, 99, 235, 1)', underLineColor: 'rgba(37, 99, 235, 0.15)', isTransparent: true, locale: 'en'
    });
    injectTradingViewWidget(cadRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'FX:USDCAD',
      width: '100%', height: 240, dateRange: '12M', colorTheme: 'light',
      trendLineColor: 'rgba(37, 99, 235, 1)', underLineColor: 'rgba(37, 99, 235, 0.15)', isTransparent: true, locale: 'en'
    });
    injectTradingViewWidget(audRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'FX:AUDUSD',
      width: '100%', height: 240, dateRange: '12M', colorTheme: 'light',
      trendLineColor: 'rgba(37, 99, 235, 1)', underLineColor: 'rgba(37, 99, 235, 0.15)', isTransparent: true, locale: 'en'
    });
    injectTradingViewWidget(chfRef.current, 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js', {
      symbol: 'FX:USDCHF',
      width: '100%', height: 240, dateRange: '12M', colorTheme: 'light',
      trendLineColor: 'rgba(37, 99, 235, 1)', underLineColor: 'rgba(37, 99, 235, 0.15)', isTransparent: true, locale: 'en'
    });


    return () => {
      if (tapeRef.current) tapeRef.current.innerHTML = '';
      if (goldRef.current) goldRef.current.innerHTML = '';
      if (eurRef.current) eurRef.current.innerHTML = '';
      if (silverRef.current) silverRef.current.innerHTML = '';
      if (platinumRef.current) platinumRef.current.innerHTML = '';
      if (palladiumRef.current) palladiumRef.current.innerHTML = '';
      if (copperRef.current) copperRef.current.innerHTML = '';
      if (aluminumRef.current) aluminumRef.current.innerHTML = '';

      if (nickelRef.current) nickelRef.current.innerHTML = '';
      if (zincRef.current) zincRef.current.innerHTML = '';
      if (leadRef.current) leadRef.current.innerHTML = '';
      if (tinRef.current) tinRef.current.innerHTML = '';
      if (ironRef.current) ironRef.current.innerHTML = '';

      if (inrRef.current) inrRef.current.innerHTML = '';
      if (pkrRef.current) pkrRef.current.innerHTML = '';
      if (egpRef.current) egpRef.current.innerHTML = '';
      if (aedRef.current) aedRef.current.innerHTML = '';
      if (sarRef.current) sarRef.current.innerHTML = '';

      if (gbpRef.current) gbpRef.current.innerHTML = '';
      if (jpyRef.current) jpyRef.current.innerHTML = '';
      if (cadRef.current) cadRef.current.innerHTML = '';
      if (audRef.current) audRef.current.innerHTML = '';
      if (chfRef.current) chfRef.current.innerHTML = '';
    };
  }, []);

  const gridCols = (selectedMetal === 'All' && selectedFX === 'All') ? 'md:grid-cols-2' : 'md:grid-cols-1';

  return (
    <section className="relative overflow-hidden rounded-2xl border border-blue-200/60 bg-gradient-to-br from-white to-blue-50 shadow-lg">
      {/* Decorative glow */}
      <div className="pointer-events-none absolute -top-24 -right-24 h-48 w-48 rounded-full bg-blue-400/20 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-16 -left-16 h-40 w-40 rounded-full bg-cyan-400/20 blur-3xl" />

      {/* Ticker tape */}
      <div className="[&_.tradingview-widget-container]:w-full">
        <div ref={tapeRef} className="tradingview-widget-container" />
      </div>

      {/* Cards grid */}
      <div className="p-4 sm:p-6">
        <div className={`grid grid-cols-1 ${gridCols} gap-4 sm:gap-6 transition-all duration-500`}>
          {/* Metals */}
          <div className={`rounded-xl border border-white/60 bg-white/70 backdrop-blur px-3 py-4 sm:px-4 sm:py-5 shadow-sm transition-all duration-500 ${selectedFX !== 'All' ? 'hidden' : ''}`}>
            {/* Metals filter */}
            <div className="mb-3 flex items-center justify-between gap-3">
              <h3 className="text-sm font-semibold text-gray-800">Metals</h3>
              <select value={selectedMetal} onChange={(e) => { setSelectedMetal(e.target.value); setSelectedFX('All'); }} className="rounded-md border px-2 py-1 text-xs bg-white/80">
                <option>All</option>
                <option value="gold">Gold (XAU/USD)</option>
                <option value="silver">Silver (XAG/USD)</option>
                <option value="platinum">Platinum (XPT/USD)</option>
                <option value="palladium">Palladium (XPD/USD)</option>
                <option value="copper">Copper (COPPER)</option>
                <option value="aluminum">Aluminum (ALUMINIUM)</option>
                <option value="nickel">Nickel</option>
                <option value="zinc">Zinc</option>
                <option value="lead">Lead</option>
                <option value="tin">Tin</option>
                <option value="iron">Iron Ore</option>
              </select>
            </div>
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-sm font-semibold text-gray-800">Palladium (XPD/USD)</h3>
              <span className="inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-[11px] font-medium text-blue-700">Live</span>
            </div>
            <div className={`[&_.tradingview-widget-container]:w-full ${selectedMetal !== 'All' && selectedMetal !== 'palladium' ? 'hidden' : ''}`}>
              <div ref={goldRef} className="tradingview-widget-container" />
            </div>
            {/* Other metals */}
            <div className="mt-4 grid grid-cols-1 gap-3">
              {/* Silver */}
              <div className={`rounded-lg border border-white/60 bg-white/60 backdrop-blur px-3 py-3 ${selectedMetal !== 'All' && selectedMetal !== 'silver' ? 'hidden' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-xs font-medium text-gray-700">Silver (XAG/USD)</h4>
                  <span className="inline-flex items-center rounded-full bg-emerald-100 px-2 py-0.5 text-[10px] font-medium text-emerald-700">Live</span>
                </div>
                <div className="[&_.tradingview-widget-container]:w-full">
                  <div ref={silverRef} className="tradingview-widget-container" />
                </div>
              </div>
              {/* Platinum */}
              <div className={`rounded-lg border border-white/60 bg-white/60 backdrop-blur px-3 py-3 ${selectedMetal !== 'All' && selectedMetal !== 'platinum' ? 'hidden' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-xs font-medium text-gray-700">Platinum (XPT/USD)</h4>
                  <span className="inline-flex items-center rounded-full bg-violet-100 px-2 py-0.5 text-[10px] font-medium text-violet-700">Live</span>
                </div>
                <div className="[&_.tradingview-widget-container]:w-full">
                  <div ref={platinumRef} className="tradingview-widget-container" />
                </div>
              </div>
              {/* Gold */}
              <div className={`rounded-lg border border-white/60 bg-white/60 backdrop-blur px-3 py-3 ${selectedMetal !== 'All' && selectedMetal !== 'gold' ? 'hidden' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-xs font-medium text-gray-700">Gold (XAU/USD)</h4>
                  <span className="inline-flex items-center rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-medium text-amber-700">Live</span>
                </div>
                <div className="[&_.tradingview-widget-container]:w-full">
                  <div ref={palladiumRef} className="tradingview-widget-container" />
                </div>
              </div>
              {/* Copper */}
              <div className={`rounded-lg border border-white/60 bg-white/60 backdrop-blur px-3 py-3 ${selectedMetal !== 'All' && selectedMetal !== 'copper' ? 'hidden' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-xs font-medium text-gray-700">Copper</h4>
                  <span className="inline-flex items-center rounded-full bg-orange-100 px-2 py-0.5 text-[10px] font-medium text-orange-700">Live</span>
                </div>
                <div className="[&_.tradingview-widget-container]:w-full">
                  <div ref={copperRef} className="tradingview-widget-container" />
                </div>
              </div>
              {/* Aluminum */}
              <div className={`rounded-lg border border-white/60 bg-white/60 backdrop-blur px-3 py-3 ${selectedMetal !== 'All' && selectedMetal !== 'aluminum' ? 'hidden' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-xs font-medium text-gray-700">Aluminum</h4>
                  <span className="inline-flex items-center rounded-full bg-sky-100 px-2 py-0.5 text-[10px] font-medium text-sky-700">Live</span>
                </div>
                <div className="[&_.tradingview-widget-container]:w-full">
                  <div ref={aluminumRef} className="tradingview-widget-container" />
                </div>
              </div>
              {/* Nickel */}
              <div className={`rounded-lg border border-white/60 bg-white/60 backdrop-blur px-3 py-3 ${selectedMetal !== 'All' && selectedMetal !== 'nickel' ? 'hidden' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-xs font-medium text-gray-700">Nickel</h4>
                  <span className="inline-flex items-center rounded-full bg-indigo-100 px-2 py-0.5 text-[10px] font-medium text-indigo-700">Live</span>
                </div>
                <div className="[&_.tradingview-widget-container]:w-full">
                  <div ref={nickelRef} className="tradingview-widget-container" />
                </div>
              </div>
              {/* Zinc */}
              <div className={`rounded-lg border border-white/60 bg-white/60 backdrop-blur px-3 py-3 ${selectedMetal !== 'All' && selectedMetal !== 'zinc' ? 'hidden' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-xs font-medium text-gray-700">Zinc</h4>
                  <span className="inline-flex items-center rounded-full bg-emerald-100 px-2 py-0.5 text-[10px] font-medium text-emerald-700">Live</span>
                </div>
                <div className="[&_.tradingview-widget-container]:w-full">
                  <div ref={zincRef} className="tradingview-widget-container" />
                </div>
              </div>
              {/* Lead */}
              <div className={`rounded-lg border border-white/60 bg-white/60 backdrop-blur px-3 py-3 ${selectedMetal !== 'All' && selectedMetal !== 'lead' ? 'hidden' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-xs font-medium text-gray-700">Lead</h4>
                  <span className="inline-flex items-center rounded-full bg-orange-100 px-2 py-0.5 text-[10px] font-medium text-orange-700">Live</span>
                </div>
                <div className="[&_.tradingview-widget-container]:w-full">
                  <div ref={leadRef} className="tradingview-widget-container" />
                </div>
              </div>
              {/* Tin */}
              <div className={`rounded-lg border border-white/60 bg-white/60 backdrop-blur px-3 py-3 ${selectedMetal !== 'All' && selectedMetal !== 'tin' ? 'hidden' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-xs font-medium text-gray-700">Tin</h4>
                  <span className="inline-flex items-center rounded-full bg-sky-100 px-2 py-0.5 text-[10px] font-medium text-sky-700">Live</span>
                </div>
                <div className="[&_.tradingview-widget-container]:w-full">
                  <div ref={tinRef} className="tradingview-widget-container" />
                </div>
              </div>
              {/* Iron Ore */}
              <div className={`rounded-lg border border-white/60 bg-white/60 backdrop-blur px-3 py-3 ${selectedMetal !== 'All' && selectedMetal !== 'iron' ? 'hidden' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-xs font-medium text-gray-700">Iron Ore</h4>
                  <span className="inline-flex items-center rounded-full bg-teal-100 px-2 py-0.5 text-[10px] font-medium text-teal-700">Live</span>
                </div>
                <div className="[&_.tradingview-widget-container]:w-full">
                  <div ref={ironRef} className="tradingview-widget-container" />
                </div>
              </div>
            </div>
          </div>

          {/* EUR/USD mini chart + other FX */}
          <div className={`rounded-xl border border-white/60 bg-white/70 backdrop-blur px-3 py-4 sm:px-4 sm:py-5 shadow-sm transition-all duration-500 ${selectedMetal !== 'All' ? 'hidden' : ''}`}>
            {/* FX filter */}
            <div className="mb-3 flex items-center justify-between gap-3">
              <h3 className="text-sm font-semibold text-gray-800">Currencies</h3>
              <select value={selectedFX} onChange={(e) => { setSelectedFX(e.target.value); setSelectedMetal('All'); }} className="rounded-md border px-2 py-1 text-xs bg-white/80">
                <option>All</option>
                <option value="eurusd">EUR/USD</option>
                <option value="usdinr">USD/INR</option>
                <option value="usdpkr">USD/PKR</option>
                <option value="usdegp">USD/EGP</option>
                <option value="usdaed">USD/AED</option>
                <option value="usdsar">USD/SAR</option>
                <option value="gbpusd">GBP/USD</option>
                <option value="usdjpy">USD/JPY</option>
                <option value="usdcad">USD/CAD</option>
                <option value="audusd">AUD/USD</option>
                <option value="usdchf">USD/CHF</option>
              </select>
            </div>
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-sm font-semibold text-gray-800">EUR/USD Mini Chart</h3>
              <span className="inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-[11px] font-medium text-blue-700">Live</span>
            </div>
            <div className={`[&_.tradingview-widget-container]:w-full ${selectedFX !== 'All' && selectedFX !== 'eurusd' ? 'hidden' : ''}`}>
              <div ref={eurRef} className="tradingview-widget-container" />
            </div>
            {/* Additional currency conversions */}
            <div className="mt-4 grid grid-cols-1 gap-3">
              {/* USD/INR */}
              <div className={`rounded-lg border border-white/60 bg-white/60 backdrop-blur px-3 py-3 ${selectedFX !== 'All' && selectedFX !== 'usdinr' ? 'hidden' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-xs font-medium text-gray-700">USD/INR</h4>
                  <span className="inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-[10px] font-medium text-blue-700">Live</span>
                </div>
                <div className="[&_.tradingview-widget-container]:w-full">
                  <div ref={inrRef} className="tradingview-widget-container" />
                </div>
              </div>
              {/* USD/PKR */}
              <div className={`rounded-lg border border-white/60 bg-white/60 backdrop-blur px-3 py-3 ${selectedFX !== 'All' && selectedFX !== 'usdpkr' ? 'hidden' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-xs font-medium text-gray-700">USD/PKR</h4>
                  <span className="inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-[10px] font-medium text-blue-700">Live</span>
                </div>
                <div className="[&_.tradingview-widget-container]:w-full">
                  <div ref={pkrRef} className="tradingview-widget-container" />
                </div>
              </div>
              {/* USD/EGP */}
              <div className={`rounded-lg border border-white/60 bg-white/60 backdrop-blur px-3 py-3 ${selectedFX !== 'All' && selectedFX !== 'usdegp' ? 'hidden' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-xs font-medium text-gray-700">USD/EGP</h4>
                  <span className="inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-[10px] font-medium text-blue-700">Live</span>
                </div>
                <div className="[&_.tradingview-widget-container]:w-full">
                  <div ref={egpRef} className="tradingview-widget-container" />
                </div>
              </div>
              {/* USD/AED */}
              <div className={`rounded-lg border border-white/60 bg-white/60 backdrop-blur px-3 py-3 ${selectedFX !== 'All' && selectedFX !== 'usdaed' ? 'hidden' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-xs font-medium text-gray-700">USD/AED</h4>
                  <span className="inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-[10px] font-medium text-blue-700">Live</span>
                </div>
                <div className="[&_.tradingview-widget-container]:w-full">
                  <div ref={aedRef} className="tradingview-widget-container" />
                </div>
              </div>
              {/* USD/SAR */}
              <div className={`rounded-lg border border-white/60 bg-white/60 backdrop-blur px-3 py-3 ${selectedFX !== 'All' && selectedFX !== 'usdsar' ? 'hidden' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-xs font-medium text-gray-700">USD/SAR</h4>
                  <span className="inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-[10px] font-medium text-blue-700">Live</span>
                </div>
                <div className="[&_.tradingview-widget-container]:w-full">
                  <div ref={sarRef} className="tradingview-widget-container" />
                </div>
              </div>
              {/* GBP/USD */}
              <div className={`rounded-lg border border-white/60 bg-white/60 backdrop-blur px-3 py-3 ${selectedFX !== 'All' && selectedFX !== 'gbpusd' ? 'hidden' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-xs font-medium text-gray-700">GBP/USD</h4>
                  <span className="inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-[10px] font-medium text-blue-700">Live</span>
                </div>
                <div className="[&_.tradingview-widget-container]:w-full">
                  <div ref={gbpRef} className="tradingview-widget-container" />
                </div>
              </div>
              {/* USD/JPY */}
              <div className={`rounded-lg border border-white/60 bg-white/60 backdrop-blur px-3 py-3 ${selectedFX !== 'All' && selectedFX !== 'usdjpy' ? 'hidden' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-xs font-medium text-gray-700">USD/JPY</h4>
                  <span className="inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-[10px] font-medium text-blue-700">Live</span>
                </div>
                <div className="[&_.tradingview-widget-container]:w-full">
                  <div ref={jpyRef} className="tradingview-widget-container" />
                </div>
              </div>
              {/* USD/CAD */}
              <div className={`rounded-lg border border-white/60 bg-white/60 backdrop-blur px-3 py-3 ${selectedFX !== 'All' && selectedFX !== 'usdcad' ? 'hidden' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-xs font-medium text-gray-700">USD/CAD</h4>
                  <span className="inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-[10px] font-medium text-blue-700">Live</span>
                </div>
                <div className="[&_.tradingview-widget-container]:w-full">
                  <div ref={cadRef} className="tradingview-widget-container" />
                </div>
              </div>
              {/* AUD/USD */}
              <div className={`rounded-lg border border-white/60 bg-white/60 backdrop-blur px-3 py-3 ${selectedFX !== 'All' && selectedFX !== 'audusd' ? 'hidden' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-xs font-medium text-gray-700">AUD/USD</h4>
                  <span className="inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-[10px] font-medium text-blue-700">Live</span>
                </div>
                <div className="[&_.tradingview-widget-container]:w-full">
                  <div ref={audRef} className="tradingview-widget-container" />
                </div>
              </div>
              {/* USD/CHF */}
              <div className={`rounded-lg border border-white/60 bg-white/60 backdrop-blur px-3 py-3 ${selectedFX !== 'All' && selectedFX !== 'usdchf' ? 'hidden' : ''}`}>
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-xs font-medium text-gray-700">USD/CHF</h4>
                  <span className="inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-[10px] font-medium text-blue-700">Live</span>
                </div>
                <div className="[&_.tradingview-widget-container]:w-full">
                  <div ref={chfRef} className="tradingview-widget-container" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

